export default __webpack_public_path__ + "static/media/email.04cc36c0.svg";